import * as React from 'react';
import { compose } from 'recompose';
import * as moment from 'moment';
import { Moment } from 'moment';
import { connect, MapDispatchToProps } from 'react-redux';

import Calendar, { ICalendarProps } from 'src/components/Calendar';

import { ISelectOptionType } from 'src/components/Select';
import IMPComponent from 'src/components/interfaces/IMPComponent';

import * as pagesCalendarActions from './actions';

import { getWordsCountToDays } from '../selectors';
import { getExpectedWordsCount } from 'src/containers/UserProfile/selectors';
import { getSelectedDate, getSelectedMonth, getSelectedYear } from './selectors';

import withActionsDispatch from 'src/hocs/withActionsDispatch';
import { DefaultDateFormats } from '../../../constants/dateFormats';

enum NavDirection {
  next = 'next',
  prev = 'prev',
}

interface IPagesHistoryCalendarProps {
  selectPagesHistoryCalendarDate: typeof pagesCalendarActions.selectPagesHistoryCalendarDate;
  selectPagesHistoryCalendarMonth: typeof pagesCalendarActions.selectPagesHistoryCalendarMonth;
  selectPagesHistoryCalendarYear: typeof pagesCalendarActions.selectPagesHistoryCalendarYear;
}

const enhance = compose<ICalendarProps, IMPComponent>(
  connect(
    (state): ICalendarProps => {
      return {
        month: getSelectedMonth(state),
        year: getSelectedYear(state),
        expectedWordsCount: getExpectedWordsCount(state),
        selectedDate: getSelectedDate(state),
        wordsCountToDays: getWordsCountToDays(state),
      };
    },
    pagesCalendarActions as MapDispatchToProps<IPagesHistoryCalendarProps, ICalendarProps>,
  ),
  withActionsDispatch({
    onMount: [pagesCalendarActions.startPagesCalendarSaga()],
    onUnmount: [pagesCalendarActions.cancelPagesCalendarSaga()],
  }),
);

class PagesHistoryCalendar extends React.PureComponent<ICalendarProps & IPagesHistoryCalendarProps> {
  public render() {
    return (
      <Calendar
        {...this.props}
        onNextClick={this.handleNextClick}
        onPrevClick={this.handlePrevClick}
        onMonthChange={this.handleMonthChange}
        onYearChange={this.handleYearChange}
        onDayClick={this.handleDayClick}
      />
    );
  }

  private handleMonthChange = (data: ISelectOptionType) => {
    const { selectPagesHistoryCalendarMonth } = this.props;

    selectPagesHistoryCalendarMonth(data.value);
  };

  private handleYearChange = (data: ISelectOptionType) => {
    const { selectPagesHistoryCalendarYear } = this.props;

    selectPagesHistoryCalendarYear(data.value);
  };

  private handleDayClick = (data: Date) => {
    const { selectPagesHistoryCalendarDate } = this.props;

    selectPagesHistoryCalendarDate(moment(data).format(DefaultDateFormats.fullDate));
  };

  private handleNextClick = () => {
    const { month, year, selectedDate } = this.props;

    const nextMonthAndYear = moment(selectedDate)
      .year(year)
      .month(month)
      .add(1, 'month');

    this.handleCalendarNav(nextMonthAndYear, NavDirection.next);
  };

  private handlePrevClick = () => {
    const { month, year, selectedDate } = this.props;

    const nextMonthAndYear = moment(selectedDate)
      .year(year)
      .month(month)
      .subtract(1, 'month');

    this.handleCalendarNav(nextMonthAndYear, NavDirection.prev);
  };

  private handleCalendarNav(nextMonthAndYear: Moment, direction: NavDirection) {
    const { selectPagesHistoryCalendarYear, selectPagesHistoryCalendarMonth, year } = this.props;

    const yearChanged = nextMonthAndYear.year() !== year;

    let nextMonth = nextMonthAndYear.month();

    if (yearChanged) {
      selectPagesHistoryCalendarYear(nextMonthAndYear.year());
    }

    if (yearChanged) {
      nextMonth = direction === NavDirection.next ? 0 : 11;
    }

    selectPagesHistoryCalendarMonth(nextMonth);
  }
}

export default enhance(PagesHistoryCalendar);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PagesHistoryCalendar/index.tsx